import RoleType from '@/models/roleType';

const employeeSearchPageRouteName = 'purchaseOrderSearch';
const supplierSearchPageRouteName = 'orderSearchLookup';

const RolesHelper = {
  getRoleHomeRouteName(roles) {
    const mainRoleName = this.getMainRole(roles);

    switch (mainRoleName) {
      case RoleType.Supplier.key:
        return supplierSearchPageRouteName;
      case RoleType.Merchandiser.key:
        return 'mylist';
      case RoleType.Manager.key:
      case RoleType.Admin.key:
      case RoleType.RolesManager.key:
        return 'users';
      default:
        return employeeSearchPageRouteName;
    }
  },

  getMainRole(roles) {
    const sorted = roles.sort((a, b) => RoleType.get(a).value - RoleType.get(b).value);

    return sorted[0] || null;
  },

  getRoleSearchRouteName(roles) {
    const mainRoleName = this.getMainRole(roles);

    switch (mainRoleName) {
      case RoleType.Supplier.key:
        return supplierSearchPageRouteName;
      case RoleType.Merchandiser.key:
      case RoleType.Manager.key:
      case RoleType.Admin.key:
      default:
        return employeeSearchPageRouteName;
    }
  },

  getRoleLogoRouteName(roles) {
    const mainRoleName = this.getMainRole(roles);

    switch (mainRoleName) {
      case RoleType.RolesManager.key:
        return 'users';
      case RoleType.Supplier.key:
        return supplierSearchPageRouteName;
      case RoleType.Merchandiser.key:
      case RoleType.Manager.key:
      case RoleType.Admin.key:
      default:
        return employeeSearchPageRouteName;
    }
  },

  getSupplierSearchPageRouteName() {
    return supplierSearchPageRouteName;
  },

  getEmployeeSearchPageRouteName() {
    return employeeSearchPageRouteName;
  },
};

export default RolesHelper;
